var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Loader'):_c('div',[_c('BaseFormGroup',[_c('BaseFormLabel',{attrs:{"for":`${_vm._uid}-form-id`}},[_vm._v(" Form * ")]),_c('BaseFormSelect',{attrs:{"value":_vm.defaultData.form_id,"options":_vm.options,"id":`${_vm._uid}-form-id`},on:{"input":_vm.setProps}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }